import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  SiaHttpService,
  SiaSessionService,
  SiaUtilsService,
  notify,
} from '@sia/shared';
import CustomStore from 'devextreme/data/custom_store';
import { GridHttpParams } from '../interfaces/grid-http-params';

@Injectable({
  providedIn: 'root',
})
export class GridDataApi {
  #sessionService = inject(SiaSessionService);
  #utilsService = inject(SiaUtilsService);
  #httpService = inject(SiaHttpService);

  getStore(
    controllers: any,
    gridId: string,
    useSp: boolean,
    useCache: boolean,
    cacheKey: string,
    keysIds: string[],
    gridComponent: any,
  ): CustomStore {
    let defController = controllers.default;
    let addController = controllers.insert ?? controllers.default;
    let editController = controllers.edit ?? controllers.default;
    let deleteController = controllers.delete ?? controllers.default;
    let httpService = this.#httpService;
    let session = this.#sessionService;
    if (useCache && !cacheKey) cacheKey = gridId;
    let cs = new CustomStore({
      key: keysIds,

      load: function (loadOptions: any): any {
        if (!gridComponent.reloadPageIndex) {
          gridComponent.reloadPageIndex = 0;
        }
        var key = 'grid-sp-parameters' + gridId;
        var spParams = session.get(key);
        let filterValue = '';
        if (gridComponent.dataGrid?.filterValue) {
          if (
            Array.isArray(gridComponent.dataGrid.filterValue) &&
            gridComponent.dataGrid.filterValue.length > 0
          ) {
            filterValue = JSON.stringify(gridComponent.dataGrid?.filterValue);
          } else if (!Array.isArray(gridComponent.dataGrid.filterValue)) {
            filterValue = JSON.stringify(gridComponent.dataGrid?.filterValue);
          }
        }
        var currentSort = JSON.stringify(loadOptions.sort);
        if (
          gridComponent.previousSort &&
          currentSort != gridComponent.previousSort
        ) {
          gridComponent.reloadPageIndex = 0;
        }

        gridComponent.previousSort = currentSort;

        let params: GridHttpParams = {
          columns: gridComponent.columns.map((x: any) => x.dataField),
          skip: loadOptions.skip,
          take: loadOptions.take,
          sort: JSON.stringify(loadOptions.sort),
          filter: filterValue,
          componentId: gridId,
          spParams: JSON.stringify(spParams),
          requireTotalCount: loadOptions.requireTotalCount,
          totalSummary: loadOptions.totalSummary
            ? JSON.stringify(loadOptions.totalSummary)
            : undefined,
        };
        gridComponent.reloadPageIndex += loadOptions.take;
        if (!useSp) {
          if (useCache) {
            return httpService
              .getUsingPostCache(`${defController}/page`, params, cacheKey)
              .then((dto: any) => {
                let r = {
                  data: dto.items,
                  totalCount: dto.totalCount,
                  summary: dto.summaries,
                };
                afterLoad();

                return r;
              })
              .catch((error) => {
                console.error('Errore in POST CACHE DATI GRID');
                console.error(error);
              });
          } else {
            return httpService
              .post(`${defController}/page`, params)
              .then((dto: any) => {
                let r = {
                  data: dto.items,
                  totalCount: dto.totalCount,
                  summary: dto.summaries,
                };
                afterLoad();
                return r;
              })
              .catch((error) => {
                console.error('Errore in POST DATI GRID');
                console.error(error);
              });
          }
        } else {
          if (useCache) {
            //TOLTO PER VIA  DI PROBLEMA CHACHE if (useCache)
            return httpService
              .getUsingPostCache(`${defController}/page-sp`, params, cacheKey)
              .then((dto: any) => {
                let r = {
                  data: dto.items,
                  totalCount: dto.totalCount,
                  summary: dto.summaries,
                };
                afterLoad();

                return r;
              })
              .catch((error) => {
                console.error('Errore in GET');
                console.error(error);
              });
          } else {
            return httpService
              .post(`${defController}/page-sp`, params)
              .then((dto: any) => {
                let r = {
                  data: dto.items,
                  totalCount: dto.totalCount,
                  summary: dto.summaries,
                };
                afterLoad();

                return r;
              })
              .catch((error) => {
                console.error('Errore in GET');
                console.error(error);
              });
          }
        }
      },
      insert: (values) => {
        let toPersistData = {
          componentId: gridId,
          jsonData: JSON.stringify(values),
        };

        return httpService
          .postCache(cacheKey, `${addController}/insert`, toPersistData, {}, '')
          .then((_) => {
            this.#utilsService.onGridInsertedRow(_);
            notify('Salvato con successo', 2000, 'success');
          })
          .catch((e: any) => {
            this.#utilsService.notifyErrorOnException(e, 'sia-grid-data-api');
          });
      },
      update: (key, values) => {
        let toPersistData: any = {
          componentId: gridId,
          jsonData: JSON.stringify({ key, values }),
        };
        return httpService
          .putCache(`${editController}/update`, toPersistData, cacheKey, {}, '')
          .then((_) => {
            notify('Aggiornato con successo', 2000, 'success');
          })
          .catch((e: any) => {
            this.#utilsService.notifyErrorOnException(e, 'sia-grid-data-api');
          });
      },
      remove: (key) => {
        let params = new HttpParams();
        params = params.set('componentId', `${gridId}`);
        params = params.set('jsonData', `${JSON.stringify(key)}`);
        let options = { params };
        return httpService
          .deleteCache(`${deleteController}/delete`, cacheKey, options, '')
          .then((_) => {
            if (_) notify('Eliminato con successo', 2000, 'success');
          })
          .catch((e: any) => {
            this.#utilsService.notifyErrorOnException(e, 'sia-grid-data-api');
          });
      },
    });
    return cs;

    function afterLoad() {
      if (gridComponent.firstLoad) {
        setTimeout(() => {
          gridComponent.firstLoad = false;
          // gridComponent.dataGrid?.instance
          //   .getScrollable()
          //   .scrollBy(gridComponent.scrollTop);
          //           // gridComponent.dataGrid?.instance
          //   .getScrollable()
          //   .on('scroll', () => gridComponent.gridScolled());
          // console.log('NAVIGO VERSO RIGA', gridComponent.clickedKey);
          // gridComponent.dataGrid?.instance.navigateToRow(
          //   gridComponent.clickedKey
          // );
          // gridComponent.dataGrid?.instance.pageIndex(
          //   gridComponent.statePageIndex
          // );
          if (gridComponent.dataGrid) {
            // console.log('VADO A ', gridComponent.focusedRowIndex);
            gridComponent.dataGrid.instance.pageIndex(
              gridComponent.statePageIndex,
            );
            gridComponent.settedPageIndex = true;
          }
        }, 0);
      }
    }
  }

  getFilterDataSource(
    controllerId: string,
    componentId: string | null,
    dataField: string | undefined,
    filters: string | undefined,
  ) {
    let p = {
      componentId: componentId,
      dataField: dataField,
      filters: filters,
    };
    return this.#httpService.post(`${controllerId}/filter-datasource`, p);
  }

  idsClick(
    idsSP: string | undefined,
    ids: string,
    gridId: string,
  ): Promise<boolean> {
    let idsSpParams = {
      ids: ids,
      spName: idsSP,
      componentId: gridId,
    };
    return this.#httpService.post(`griddata/ids-sp`, idsSpParams);
  }
}
